import { getEnvVar } from "./env";

const tenantLogos = import.meta.glob("/src/assets/images/tenants/*.png", { eager: true, import: "default" });

export const Tenant = {
    getId: () => getEnvVar("VITE_TENANT_ID") || "default",
    getName: () => getEnvVar("VITE_TENANT_NAME") || "***tenant name***",
    getLogo: () => tenantLogos[`/src/assets/images/tenants/${Tenant.getId()}.png`],
    getTheme: () => getEnvVar("VITE_THEME"),
    getWebsite: () => getEnvVar("VITE_TENANT_WEBSITE"),
    getGoogleAuthHostedDomain: () => getEnvVar("VITE_GOOGLE_AUTH_HOSTED_DOMAIN"),
    getFeatures: () => ({
        forms: {
            enabled: getEnvVar("VITE_FEATURES_FORMS_ENABLED") === "true",
        },
        campaigns: {
            enabled: getEnvVar("VITE_FEATURES_CAMPAIGNS_ENABLED") === "true",
        },
        visitors: {
            enabled: getEnvVar("VITE_FEATURES_VISITORS_ENABLED") === "true",
        },
        signinSheet: {
            enabled: getEnvVar("VITE_FEATURES_SIGNIN_SHEET_ENABLED") === "true",
        },
        chainOfCustody: {
            enabled: getEnvVar("VITE_FEATURES_CHAIN_OF_CUSTODY_ENABLED") === "true",
        },
        masterCalendar: {
            enabled: getEnvVar("VITE_FEATURES_MASTER_CALENDAR_ENABLED") === "true",
        },
        pos: {
            enabled: getEnvVar("VITE_FEATURES_POS_ENABLED") === "true",
        },
        invoicing: {
            enabled: getEnvVar("VITE_FEATURES_INVOICING_ENABLED") === "true",
        },
        internalChat: {
            enabled: getEnvVar("VITE_FEATURES_INTERNAL_CHAT_ENABLED") === "true",
        },
        calendar: {
            enabled: getEnvVar("VITE_FEATURES_CALENDAR_ENABLED") === "true",
        },
        home: {
            enabled: getEnvVar("VITE_FEATURES_HOME_ENABLED") === "true",
        },
        modules: {
            enabled: getEnvVar("VITE_FEATURES_MODULES_ENABLED") === "true",
        },
    }),
};
